// extracted by mini-css-extract-plugin
module.exports = {"className":"textBodyMStrong_className__yXgeE"};